<div class="min-h-screen flex flex-col bg-gray-50">
  <!-- Cabeçalho -->
  <div class="flex justify-between items-center px-6 py-4 bg-orange-600 shrink-0">
    <h1 class="text-xl font-bold text-white">Pré-Vendas Pendentes</h1>
    <button
      type="button"
      (click)="voltar()"
      class="bg-orange-700 hover:bg-orange-800 text-white px-4 py-2 rounded font-medium">
      ESC - VOLTAR
    </button>
  </div>

  <!-- Filtro (por nome do cliente ou código da pré-venda) -->
  <div class="px-6 py-4 bg-white border-b border-gray-200 shrink-0">
    <input
      type="text"
      [(ngModel)]="filterTerm"
      (input)="onFilterChange()"
      placeholder="Filtre por cliente ou código..."
      class="w-full border-b-2 border-orange-500 focus:border-orange-600 outline-none py-2 text-gray-800" />
  </div>

  <!-- Lista (estilo card igual à lista de produtos) -->
  <div class="flex-1 min-h-0 overflow-auto px-6 py-4">
    <div class="flex flex-col gap-1" *ngIf="preVendas.length > 0">
      <p class="text-sm font-semibold text-gray-700 mb-2 sticky top-0 bg-gray-50 pb-2 z-10">
        Resultados da busca ({{ preVendas.length }})
      </p>
      <div
        *ngFor="let preVenda of preVendas; let i = index"
        [id]="'pre-venda-item-' + i"
        (click)="onRowSelect(preVenda, i)"
        [ngClass]="{
          'bg-orange-500 text-white': selectedItemIndex === i,
          'bg-white hover:bg-orange-50': selectedItemIndex !== i && i % 2 === 0,
          'bg-orange-50 hover:bg-orange-100': selectedItemIndex !== i && i % 2 !== 0
        }"
        class="p-3 rounded cursor-pointer border border-gray-200 transition-colors">
        <div class="flex flex-col">
          <div class="flex justify-between items-start">
            <span class="font-semibold text-sm" [ngClass]="{'text-white': selectedItemIndex === i, 'text-gray-900': selectedItemIndex !== i}">
              {{ preVenda.customerName || 'Não informado' }}
            </span>
            <span class="font-bold text-sm" [ngClass]="{'text-white': selectedItemIndex === i, 'text-orange-600': selectedItemIndex !== i}">
              R$ {{ preVenda.netTotal | number: '1.2-2' }}
            </span>
          </div>
          <div class="flex justify-between items-center mt-1">
            <span class="text-xs" [ngClass]="{'text-orange-100': selectedItemIndex === i, 'text-gray-600': selectedItemIndex !== i}">
              Código: {{ preVenda.id ?? '-' }} | {{ (preVenda.createdAt ? (preVenda.createdAt | date: 'dd/MM/yyyy HH:mm') : '-') }}
            </span>
            <span class="text-xs font-medium" [ngClass]="{'text-orange-100': selectedItemIndex === i, 'text-red-500': selectedItemIndex !== i}">
              Desconto: R$ {{ preVenda.discount | number: '1.2-2' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="preVendas.length === 0 && !loading" class="flex flex-col justify-center flex-1 text-center text-gray-500 py-12">
      <p>Nenhuma pré-venda localizada.</p>
    </div>
    <div *ngIf="loading" class="flex flex-col justify-center flex-1 text-center text-gray-500 py-12">
      <p>Carregando...</p>
    </div>

    <!-- Botão Importar -->
    <div class="flex justify-center mt-6">
      <button
        type="button"
        (click)="importar()"
        [disabled]="loading"
        class="bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white px-8 py-3 rounded font-medium">
        ENTER - IMPORTAR
      </button>
    </div>
  </div>

  <!-- Rodapé -->
  <div class="mt-auto shrink-0 px-6 py-3 bg-orange-600 text-white text-sm">
    Qtd de Pré-Vendas: {{ preVendas.length }} | Total: R$ {{ totalLista | number: '1.2-2' }}
  </div>
</div>

<p-toast></p-toast>
